import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import TextareaAutosize from '@mui/material/TextareaAutosize'

const useStyles = makeStyles(openQuestionStyles)

export default function OpenQuestion ({context, section, question, questionIndex}) {

  const classes = useStyles()
  const {translate, quizAssessmentToTake: assessment, assessment: assessmentId} = context

  const answer = assessment.answers[question.id]

  function handleChange (e) {
    const value = e.target.value
    const completed = value.length > 0
    context.updateState({quizAssessmentToTake: {answers: {[question.id]: {value: {$set: value}, completed: {$set: completed}}}}})
  }

  function handleBlur () {
    context.saveAnswers({id: assessmentId, answers: assessment.answers})
  }

  return (
    <Box className={classes.root}>
      <TextareaAutosize
        className={classes.textarea}
        maxRows={5}
        minRows={5}
        value={answer.value}
        onKeyPress = {({key}) => {
          key == 'Enter' && handleBlur()
        }}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </Box>
  );
}

function openQuestionStyles (theme) {
  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      paddingBottom: 20,
      flexDirection: 'column',
    },
    textarea: {
      resize: 'none',
      width: 'auto',
      padding: 8,
      flexGrow: 1,
      borderRadius: '4px',
      border: 'solid 1px #c2c7ca',
    },
  }
}
